import { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { Modal } from "../../../../../../../shared/components";
import { AltaContext, EndosoContext } from "../../../../../context";
import { useStyles } from "./styles";
import { Input, Select, DatePicker } from "..";
import { useOptions, usePersonValidation } from "../../hooks";
import { AuthContext } from "../../../../../../../context/context";
import { dateFomated } from "pages/endoso/hooks";

function monthDiff(d1, d2) {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

function dayDiff(d1, d2, time) {
  if (time === 1) {
    return d1 > d2;
  } else return d1 !== d2;
}

function getAge(birthDate) {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  const monthValidation = () => {
    const month = monthDiff(birthDate, today);
    return (
      month < 3 ||
      (month <= 3 && dayDiff(birthDate.getDate(), today.getDate(), 1))
    );
  };

  const oldMonthValidation = () => {
    const month = monthDiff(birthDate, today);
    return month > 828 || dayDiff(birthDate.getDate(), today.getDate(), 2);
  };

  return {
    age: age,
    month: monthDiff(birthDate, today),
    underMonth: monthValidation(),
    upToMonth: oldMonthValidation(),
  };
}

export const ModalForm = () => {
  const classes = useStyles();
  const { setTimer, persons, setPersons } = useContext(AuthContext);
  const { createMessage, setShowMessage, setMessage } =
    useContext(EndosoContext);
  const {
    showModal,
    closeModal,
    currentTitular,
    handleChange,
    situacion,
    setFamiliares,
    familiares,
    titulares,
    setTitulares,
    initialData,
  } = useContext(AltaContext);
  const isSpecialCase = initialData?.formaAseguramiento === "002";
  const {
    sexOptions,
    relationOptions,
    agrupadoresOptions,
    categoriaOptions,
    reglaOptions,
    tReglaOptions,
    asociadoOptions,
    reglaBOptions,
    tReglaBOptions,
    relationOptions902,
  } = useOptions({ type: isSpecialCase ? situacion?.parentesco : undefined });
  const { isValid, text } = usePersonValidation();
  const [optionsSpecialCase, setOptionsSpecialCase] =
    useState(relationOptions902);
  const mailHolder = asociadoOptions?.find((t) => t.id === situacion.parentId);
  const showAsociados = situacion?.parentesco !== "T" || currentTitular;
  /* methods */
  const handleSubmitData = () => {
    setTimer(0);

    const years = getAge(situacion.fchNacimineto);
    if (
      years.age > 69 ||
      (years.age === 69 && years.upToMonth) ||
      (years.age === 0 && years.underMonth)
    ) {
      setMessage({
        text: "Verifica la fecha. Edad permitida: Mayor de 3 meses y Menor de 69 años.",
        severity: "warning",
      });
      setShowMessage(true);
    } else {
      const fullName = `${situacion.primerNombre} ${
        situacion.segundoNombre ?? ""
      } ${situacion.apPaterno} ${situacion.apMaterno ?? ""}`;
      setPersons([
        ...(Array.isArray(persons) ? persons : []),
        {
          ...situacion,
          fchNacimineto: dateFomated(situacion.fchNacimineto),
          nombre: fullName,
          antiguedad: dateFomated(new Date()),
          titular: mailHolder?.titular,
        },
      ]);
      createMessage({
        text: "Se creo el asociado de manera exitosa",
        variant: "success",
      });
      closeModal();
    }
  };

  useEffect(() => {
    if ((Boolean(currentTitular) || showAsociados) && isSpecialCase) {
      situacion.correo = mailHolder?.correoElectronico;
    }
  }, [currentTitular, situacion.parentId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentTitular?.correoElectronico && isSpecialCase) {
      situacion.correo = currentTitular.correoElectronico;
    }
  }, [currentTitular?.correoElectronico]); // eslint-disable-line react-hooks/exhaustive-deps

  const disableButton = useMemo(() => {
    const fields = [
      "primerNombre",
      "apPaterno",
      "sexo",
      "fchNacimineto",
      "parentesco",
      "agrupador",
      "categoria",
      "regla",
      "tregla",
      "antiguedad",
      ...(situacion?.parentesco !== "T" ? ["parentId"] : []),
      ...(isSpecialCase ? ["correo"] : []),
    ];
    if (situacion) {
      const emptlyFields = fields.map((field) =>
        !situacion[field] ? true : false
      );
      return emptlyFields.find((field) => field) || false;
    } else return true;
  }, [situacion]); // eslint-disable-line react-hooks/exhaustive-deps

  const categoriasFiltradas = useMemo(() => {
    if (!mailHolder?.categoria || !categoriaOptions) return categoriaOptions;

    const base = parseInt(mailHolder.categoria, 10);
    const rangoInicio = base;
    const rangoFin = base + 5;

    return categoriaOptions.filter((categoria) => {
      const value = parseInt(categoria.value, 10);
      return value > rangoInicio && value <= rangoFin;
    });
  }, [mailHolder?.categoria, categoriaOptions]);

  const saveTitular = () => {
    const { primerNombre, segundoNombre, apPaterno, apMaterno } = situacion;

    const titular = {
      ...situacion,
      id: titulares.length + 1,
      familiares: 0,
      nombre: `${primerNombre} ${segundoNombre ?? ""} ${apPaterno} ${
        apMaterno ?? ""
      }`,
    };
    setTitulares([...titulares, titular]);
    createMessage({
      text: "Se creo el titular de manera exitosa",
      variant: "success",
    });
  };
  const saveFamiliar = () => {
    const { primerNombre, segundoNombre, apPaterno, apMaterno } = situacion;
    const updateTitular = titulares.map((titular) =>
      titular.id === situacion.parentId
        ? { ...titular, familiares: titular.familiares + 1 }
        : titular
    );
    setFamiliares([
      ...familiares,
      {
        ...situacion,
        nombre: `${primerNombre} ${segundoNombre ?? ""} ${apPaterno} ${
          apMaterno ?? ""
        }`,
        id: familiares.length + 1,
      },
    ]);
    setTitulares(updateTitular);
    createMessage({
      text: "Se creo el asociado de manera exitosa",
      variant: "success",
    });
  };
  const saveSituacion = () => {
    setTimer(0);
    if (isSpecialCase) {
      handleSubmitData();
    } else if (isValid) {
      if (situacion.parentesco !== "T") saveFamiliar();
      else saveTitular();
      closeModal();
    } else createMessage({ text: text, variant: "warning" });
  };

  useEffect(() => {
    if (situacion.parentesco && isSpecialCase) situacion.categoria = undefined;
  }, [situacion.parentesco]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (situacion.correo && !showAsociados && isSpecialCase) {
      situacion.correo = undefined;
    }
    if (situacion) {
      situacion.parentId = undefined;
    }
  }, [showAsociados]); // eslint-disable-line react-hooks/exhaustive-deps

  const withoutParent = { ...situacion };
  delete withoutParent.parentId;
  const specialDisabled =
    Object.values(withoutParent).some((value) => value === undefined) ||
    disableButton ||
    situacion.categoria === undefined;

  useEffect(() => {
    if (Boolean(currentTitular) && isSpecialCase) {
      setOptionsSpecialCase(
        relationOptions902.filter((option) => option.value !== "T")
      );
    } else {
      setOptionsSpecialCase(relationOptions902);
    }
  }, [currentTitular, isSpecialCase]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal open={showModal} close={closeModal} className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h5" className={classes.title}>
          Agregar nuevo asegurado
        </Typography>
      </Box>
      <Grid container className={classes.section} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.title}>
            Datos Personales
          </Typography>
        </Grid>
        <Input
          name="primerNombre"
          label="Primer Nombre"
          required
          onChange={handleChange}
          onlyLetters
        />
        <Input
          name="segundoNombre"
          label="Segundo Nombre"
          onChange={handleChange}
          onlyLetters
        />
        <Input
          name="apPaterno"
          label="Apellido Paterno"
          required
          onChange={handleChange}
          onlyLetters
        />
        <Input
          name="apMaterno"
          label="Apellido Materno"
          onChange={handleChange}
          onlyLetters
        />

        <Select
          name="sexo"
          label="Sexo"
          required
          optionsProps={{ options: sexOptions }}
          onChange={handleChange}
        />
        <DatePicker
          name="fchNacimineto"
          label="Fecha de Nacimiento"
          value={situacion?.fchNacimineto}
          onChange={handleChange}
          required
        />
        <Select
          name="parentesco"
          label="Parentesco"
          required
          optionsProps={{
            options: isSpecialCase ? optionsSpecialCase : relationOptions,
          }}
          onChange={handleChange}
        />
        {showAsociados ? (
          <Select
            name="parentId"
            label="Titular Asociado"
            required
            value={situacion?.parentId}
            defaultValue={currentTitular?.id}
            disabled={Boolean(currentTitular)}
            onChange={handleChange}
            optionsProps={{
              options: asociadoOptions,
              value: "id",
              text: "nombre",
            }}
          />
        ) : (
          <Grid item xs={3}></Grid>
        )}
        {initialData.formaAseguramiento === "002" && (
          <>
            <Input
              label="Ocupación"
              name={"ocupacion"}
              onChange={handleChange}
              onlyLetters
            />
            <Input
              label="Correo Electrónico"
              required
              name={"correo"}
              defaultValue={
                currentTitular?.correoElectronico ??
                mailHolder?.correoElectronico
              }
              value={situacion?.correo ?? ""}
              disabled={Boolean(currentTitular) || showAsociados}
              onChange={handleChange}
              maxLength={40}
              email
            />
          </>
        )}

        <Grid item xs={12}>
          <Typography variant="body1" className={classes.title}>
            Datos De Póliza
          </Typography>
        </Grid>
        <Select
          name="agrupador"
          label="Agrupador"
          optionsProps={{ options: agrupadoresOptions }}
          required
          onChange={handleChange}
        />
        <Select
          name="categoria"
          label="Categoría"
          required
          disabled={!isSpecialCase && Boolean(situacion?.categoria)}
          optionsProps={{ options: categoriasFiltradas }}
          onChange={handleChange}
        />
        <Select
          name="regla"
          label="Regla"
          required
          optionsProps={{
            options: isSpecialCase ? reglaOptions : reglaBOptions,
          }}
          onChange={handleChange}
        />
        <Select
          name="tregla"
          label="Tipo de Regla"
          required
          optionsProps={{
            options: isSpecialCase ? tReglaOptions : tReglaBOptions,
          }}
          onChange={handleChange}
        />
      </Grid>
      <Box className={classes.actions}>
        <Button variant="text" className={classes.button} onClick={closeModal}>
          Cancelar
        </Button>
        <Button
          variant="text"
          className={classes.button}
          disabled={isSpecialCase ? specialDisabled : disableButton}
          onClick={saveSituacion}
        >
          Guardar
        </Button>
      </Box>
    </Modal>
  );
};
